<style scoped lang="scss" src="./ForgotPassword.scss"></style>
<template>
  <main class="forgot-password-container">
    <section v-if="showFormChangePassword" class="forgot-password-container__content" @keydown="handleEnterKey">
      <h1 class="title">Recuperação de</h1>
      <h1 class="title"><span class="two">Senha.</span></h1>
      <h3 class="title-three">
        Esqueceu a senha? Não se preocupe, nós te enviaremos instruções para
        recuperá-la.
      </h3>

      <InputText
          label="CPF"
          placeholder="Digite aqui o seu CPF"
          mask="###.###.###-##"
          v-model="forget.cpf"
      />
      <InputText label="E-mail" placeholder="Digite aqui" v-model="forget.email"/>

      <footer class="act">
        <div class="msgErro">{{ msgErro }}</div>
        <button class="btn" @click="onClickActForgetPassword">Continuar</button>
        <a class="back" @click="gotoChangeToLogin">
          <i class="fas fa-chevron-circle-left" />
          <span>Voltar</span>
        </a>
      </footer>
    </section>
    <!-- CODIGO TROCA SENHA -->
    <section v-show="showCodePassword" class="forgot-password-container__content" >
      <h1 class="title">Recuperação de</h1>
      <h1 class="title"><span class="two">Senha</span></h1>

      <h3 class="title-three">
        Nós enviamos um código para
        <span class="main">{{ forget.email }}</span
        >. Insira o código para prosseguirmos com sua solicitação
      </h3>

      <InputText
          label="Código"
          placeholder="Digite aqui o código"
          mask="####"
          v-model="codePassword"
      />
      <div class="label-link" @click="onClickActForgetPassword">
        Não recebeu o email? Clique para reenviar
      </div>

      <footer class="act">
        <div class="msgErro">{{ msgErro }}</div>
        <div class="btn" @click="onClickActSendCodePassword">Continuar</div>
        <div class="back" @click="gotoChangeToLogin">
          <i class="fas fa-chevron-circle-left"></i>
          <span>Voltar</span>
        </div>
      </footer>
    </section>
    <!-- TROCA DE SENHA FINAL -->
    <section v-show="showResetPassword" class="forgot-password-container__content" >
      <h1 class="title">Defina uma nova</h1>
      <h1 class="title"><span class="two">Senha</span></h1>

      <InputPassword label="Senha" placeholder="Digite aqui" v-model="formForget.psw"/>
      <section class="password-description">
        <div class="label">A senha deve possuir:</div>
        <div class="fields">
          <div class="item">
            <div class="ball" :class="{ on: checkPsw.caracter }"/>
            <div class="text">8 caracteres.</div>
          </div>
          <div class="item">
            <div class="ball" :class="{ on: checkPsw.min }"/>
            <div class="text">1 letra minúscula.</div>
          </div>
          <div class="item">
            <div class="ball" :class="{ on: checkPsw.special }"/>
            <div class="text">1 caracter especial.</div>
          </div>
          <div class="item">
            <div class="ball" :class="{ on: checkPsw.num }"/>
            <div class="text">1 número.</div>
          </div>
          <div class="item">
            <div class="ball" :class="{ on: checkPsw.max }"/>
            <div class="text">1 letra maiúscula.</div>
          </div>
        </div>
      </section>
      <InputPassword
          label="Repita a nova senha"
          placeholder="Digite aqui"
          v-model="formForget.pswRepeat"
      />

      <footer class="act">
        <div class="msgErro">{{ msgErro }}</div>
        <div class="btn" @click="onClickChangePassword">Confirmar</div>
        <div class="back" @click="gotoChangeToLogin">
          <i class="fas fa-chevron-circle-left"></i>
          <span>Voltar</span>
        </div>
      </footer>
    </section>
    <!-- TROCA SENHA OK -->
    <section v-show="showConcludePasswordChange" class="forgot-password-container__content" >
      <h1 class="title">Senha redefinida</h1>
      <h1 class="title">com <span class="two">sucesso!</span></h1>

      <h3 class="title-three">
        Sua nova senha já está funcionando. Para acessar o sistema volte para
        a tela inicial e realize o login.
      </h3>
      <div class="title-three">
        Caso algum problema ocorra, entre em contato conosco pelo suporte.
      </div>

      <footer class="act">
        <div class="btn" @click="gotoChangeToLogin">Voltar</div>
      </footer>
    </section>
    <aside>
      <Carousel/>
    </aside>
  </main>
</template>
<script>
import InputPassword from "@/components/input/password/InputPassword.vue";
import InputText from "@/components/input/text/InputText.vue";
import ApiService from "@/views/patient/main/services/ApiService";
import Carousel from "@/views/patient/main/components/Carousel.vue";

export default {
  name: "ForgotPassword",
  components: {Carousel, InputText, InputPassword},

  data() {
    return {
      msgErro: null,
      checkPsw: {
        caracter: false,
        min: false,
        special: false,
        num: false,
        max: false,
      },
      forget: {
        cpf: null,
        email: null,
      },
      codePassword: null,
      formForget: {
        psw: null,
        pswRepeat: null,
      },
      formForgetPassword: false,
      formCodePassword: false,
      formChangePassword: false,
      formChangePasswordOk: false,
      ApiService: null,
      runningForgetPassword: false,
    };
  },
  watch: {
    "formForget.psw"(val) {
      this.validateCheckPassword(val);
    },

  },
  async mounted() {
    this.ApiService = new ApiService();
  },
  computed: {
    showFormChangePassword() {
      return !this.showCodePassword && !this.showResetPassword && !this.showConcludePasswordChange
    },
    showCodePassword() {
      return this.formCodePassword
    },
    showResetPassword() {
      return (
          this.formChangePassword &&
          !this.formChangePasswordOk
      );
    },
    showConcludePasswordChange() {
      return this.formChangePasswordOk
    },
  },
  methods: {
    gotoChangeToLogin() {
      this.$router.push({path: "/"});
    },
    /**
     * Executa a ação de redefinicao de senha.
     * @async
     */
    async onClickActForgetPassword() {
      if (this.runningForgetPassword) {
        return
      }
      this.runningForgetPassword = true
      this.msgErro = null;
      if (!this.forget.cpf) {
        this.msgErro = `CPF não informado.`;
        this.runningForgetPassword = false
        return;
      }
      if (!this.forget.email) {
        this.msgErro = `E-mail não informado.`;
        this.runningForgetPassword = false
        return;
      }
      const resp = await this.ApiService.forgetPassword(this.forget);
      if (resp.success === false) {
        this.msgErro = resp.message;
        this.runningForgetPassword = false
        return;
      }
      this.formForgetPassword = false;
      this.formCodePassword = true;
      this.runningForgetPassword = false
    },
    /**
     * Lida com o envio do código de redefinição de senha.
     * Verifica se o código, CPF e e-mail foram informados e, em seguida,
     * envia os dados para a API.
     * @async
     */
    async onClickActSendCodePassword() {
      this.msgErro = null;
      if (!this.codePassword) {
        this.msgErro = `Código não informado.`;
        return;
      }
      if (!this.forget.cpf) {
        this.msgErro = `CPF não informado.`;
        return;
      }
      if (!this.forget.email) {
        this.msgErro = `E-mail não informado.`;
        return;
      }
      const resp = await this.ApiService.sendCodePassword({
        ...this.forget,
        codePassword: this.codePassword,
      });
      if (resp.success === false) {
        this.msgErro = resp.message;
        return;
      }
      this.formForgetPassword = false;
      this.formCodePassword = false;
      this.formChangePassword = true;
    },
    /**
     * Processa a alteração de senha do usuário após a validação
     * dos dados inseridos no formulário.
     * @async
     */
    async onClickChangePassword() {
      this.msgErro = null;
      if (!this.formForget.psw) {
        this.msgErro = `Senha inválida`;
        return;
      }
      if (!this.validateFormForgetPassword()) {
        this.msgErro = `Senha inválida`;
        return;
      }
      if (this.formForget.psw !== this.formForget.pswRepeat) {
        this.msgErro = `As senhas não coincidem. Por favor, verifique.`;
        return;
      }
      const resp = await this.ApiService.changePassword({
        ...this.formForget,
        ...this.forget,
      });
      if (resp.success === false) {
        this.msgErro = resp.message;
        return;
      }
      this.formChangePasswordOk = true;
    },
    /**
     * Valida a senha fornecida, verificando se ela possui:
     * - Pelo menos 8 caracteres;
     * - Pelo menos 1 número;
     * - Pelo menos 1 letra maiúscula;
     * - Pelo menos 1 letra minúscula;
     * - Pelo menos 1 caractere especial.
     * @returns {boolean} Retorna true se a senha for válida, caso contrário, false.
     */
    validateFormForgetPassword() {
      if (!this.formForget.psw) {
        return false;
      }
      // Regex para validar a senha
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      return passwordRegex.test(this.formForget.psw);
    },

    /**
     * Verifica se uma senha atende aos critérios de segurança.
     * @param {string} password - A senha a ser verificada.
     */
    validateCheckPassword(password) {
      if (!password) {
        this.checkPsw = {
          caracter: false,
          min: false,
          special: false,
          num: false,
          max: false,
        };
        return;
      }
      this.checkPsw = {
        caracter: password.length >= 8,
        min: /[a-z]/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        num: /\d/.test(password),
        max: /[A-Z]/.test(password),
      };
    },

    handleEnterKey(event) {
      if (event.key === "Enter") {
        this.onClickActForgetPassword()
      }
    },
  },

}
</script>
